import { useLocation } from 'react-router-dom'
import { useSignupSession } from './useSignupSession'
import { useSignupState } from './useSignupState'
import { useUserLocale } from './useUserLocale'
import {
  addQueryParam,
  getQueryParam,
  removeQueryParam
} from '../lib/urlHelpers'

export const useRedirectToHpidLogin = () => {
  const { redirectUri } = useSignupSession()
  const { userSession, isLoggedIn } = useSignupState()
  const { country, language } = useUserLocale()
  const location = useLocation()

  const manageAccountEnroll =
    getQueryParam(location.search, 'manageAccountEnroll') === 'true'

  const checkShouldRedirectToLogin = (isHpIdValuePropPage: boolean) => {
    return !isLoggedIn && manageAccountEnroll && isHpIdValuePropPage
  }

  const redirectToLogin = () => {
    const cjdata = getQueryParam(location.search, 'cjdata')
    const cjevent = getQueryParam(location.search, 'cjevent')
    const locale = getQueryParam(location.search, 'locale')
    const gtmDebug = getQueryParam(location.search, 'gtm_debug')

    let enhancedRedirectUri = redirectUri
    if (cjdata) {
      enhancedRedirectUri = addQueryParam(enhancedRedirectUri, 'cjdata', cjdata)
    }
    if (cjevent) {
      enhancedRedirectUri = addQueryParam(
        enhancedRedirectUri,
        'cjevent',
        cjevent
      )
    }
    if (locale) {
      enhancedRedirectUri = addQueryParam(enhancedRedirectUri, 'locale', locale)
    }
    if (gtmDebug) {
      enhancedRedirectUri = addQueryParam(
        enhancedRedirectUri,
        'gtm_debug',
        gtmDebug
      )
    }

    const postLoginRedirect = addQueryParam(
      enhancedRedirectUri,
      'fromHpidValueProp',
      'true'
    )
    const loginPath = userSession.getLoginPath({
      postLoginRedirect,
      country,
      locale: `${language}_${country}`
    })
    window.location.assign(removeQueryParam(loginPath, 'redirectUri'))
  }

  return {
    checkShouldRedirectToLogin,
    redirectToLogin
  }
}
